import React from 'react'
import { CreditApplicationCategory } from '_gql'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import { DataGrid, HeaderToolbar, useTable } from '@divvy-web/skylab.datagridnext'
import ViewControl from '@divvy-web/skylab.viewcontrol'

import { useWebTracking } from '@sputnik/tracking/WebTrackingContext'

import styles from './styles.module.scss'

const DataGridHeader = () => {
  const [getClassName] = useNameFormatter('DataGridHeader')

  const { setColumnFilters, getState } = useTable()
  const { track } = useWebTracking()

  const initialActionNeeded = getState().columnFilters.some(
    ({ id, value }) => id === 'status' && value === CreditApplicationCategory.ACTION_NEEDED,
  )

  return (
    <DataGrid.Header>
      <HeaderToolbar.Root className={styles[getClassName('')]}>
        <HeaderToolbar.Filters>
          <ViewControl
            defaultValue={initialActionNeeded ? CreditApplicationCategory.ACTION_NEEDED : CreditApplicationCategory.ALL}
            viewControlItems={[
              {
                label: (
                  <FormattedMessage
                    defaultMessage='Action needed'
                    id='sputnik.DataGridHeader__7zRUAf'
                  />
                ),
                value: CreditApplicationCategory.ACTION_NEEDED,
              },
              {
                label: (
                  <FormattedMessage
                    defaultMessage='In review'
                    id='sputnik.DataGridHeader__OXocSj'
                  />
                ),
                value: CreditApplicationCategory.IN_REVIEW,
              },
              {
                label: (
                  <FormattedMessage
                    defaultMessage='Completed'
                    id='sputnik.DataGridHeader__95stPq'
                  />
                ),
                value: CreditApplicationCategory.COMPLETED,
              },
              {
                label: (
                  <FormattedMessage
                    defaultMessage='All'
                    id='sputnik.DataGridHeader__zQvVDJ'
                  />
                ),
                value: CreditApplicationCategory.ALL,
              },
            ]}
            onValueChange={(value) => {
              switch (value) {
                case CreditApplicationCategory.ACTION_NEEDED:
                  track('se_signup__application_dashboard_home_action_needed_tab__fired')
                  break
                case CreditApplicationCategory.COMPLETED:
                  track('se_signup__application_dashboard_home_completed_tab__fired')
                  break
                case CreditApplicationCategory.IN_REVIEW:
                  track('se_signup__application_dashboard_home_in_review_tab__fired')
                  break
                case CreditApplicationCategory.ALL:
                  track('se_signup__application_dashboard_home_all_tab__fired')
                  break
                default:
                  break
              }
              setColumnFilters([{ id: 'status', value }])
            }}
          />
        </HeaderToolbar.Filters>
        <DataGrid.FlexSpacer />
        <HeaderToolbar.Search className={styles[getClassName('search')]} />
      </HeaderToolbar.Root>
    </DataGrid.Header>
  )
}

export default DataGridHeader
